import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhpDark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	viewBox: "0 0 58 59",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#d)",
			children: [
				/* @__PURE__ */ _jsx("mask", {
					id: "c",
					x: 0,
					y: 14,
					width: 57,
					height: 30,
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					children: /* @__PURE__ */ _jsx("path", {
						d: "m0.80957 28.792c0 8.1287 12.528 14.718 27.982 14.718 15.454 0 27.982-6.5898 27.982-14.718 0-8.1286-12.528-14.718-27.982-14.718-15.454 0-27.982 6.5898-27.982 14.718z",
						fill: "#fff"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#c)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "m0.80957 28.792c0 8.1287 12.528 14.718 27.982 14.718 15.454 0 27.982-6.5898 27.982-14.718 0-8.1286-12.528-14.718-27.982-14.718-15.454 0-27.982 6.5898-27.982 14.718z",
						fill: "currentColor"
					})
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "b",
					x: -1,
					y: 12,
					width: 59,
					height: 34,
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					children: /* @__PURE__ */ _jsx("path", {
						d: "m-0.35596 12.398h58.296v32.789h-58.296v-32.789z",
						fill: "#fff"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#b)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "m28.792 42.418c14.85 0 26.889-6.1004 26.889-13.626s-12.039-13.626-26.889-13.626c-14.85 0-26.889 6.1005-26.889 13.626s12.039 13.626 26.889 13.626z",
						fill: "#262626"
					})
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "a",
					x: -1,
					y: 12,
					width: 59,
					height: 34,
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					children: /* @__PURE__ */ _jsx("path", {
						d: "m-0.35596 12.398h58.296v32.789h-58.296v-32.789z",
						fill: "#fff"
					})
				}),
				/* @__PURE__ */ _jsxs("g", {
					mask: "url(#a)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "m16.013 30.481c1.2211 0 2.1327-0.2251 2.7095-0.669 0.5706-0.4393 0.9647-1.2004 1.1712-2.2621 0.1926-0.9924 0.1193-1.6853-0.218-2.0593-0.3448-0.3819-1.0903-0.5756-2.2157-0.5756h-1.9514l-1.0818 5.566h1.5862zm-6.3824 6.8563c-0.09058 0-0.17661-0.0404-0.2342-0.1105-0.05768-0.0699-0.08106-0.162-0.06376-0.251l2.867-14.75c0.0278-0.1426 0.1528-0.2456 0.2981-0.2456h6.1791c1.942 0 3.3874 0.5273 4.296 1.5673 0.9134 1.0455 1.1954 2.5069 0.8383 4.3436-0.1453 0.7483-0.3953 1.4432-0.743 2.0654-0.348 0.6229-0.808 1.1992-1.3674 1.7133-0.6696 0.6267-1.4274 1.081-2.2504 1.3484-0.81 0.2638-1.8502 0.3976-3.0917 0.3976h-2.5021l-0.7145 3.6758c-0.0277 0.1427-0.1526 0.2457-0.298 0.2457h-3.2134z",
							fill: "#fff"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "m15.758 25.219h1.7011c1.3583 0 1.8301 0.298 1.9904 0.4756 0.266 0.2949 0.3162 0.9167 0.1452 1.798-0.1921 0.9867-0.5481 1.6863-1.0584 2.0792-0.5224 0.4021-1.3718 0.606-2.5242 0.606h-1.2179l0.9638-4.9588zm2.9179-3.542h-6.1793c-0.2906 0-0.5405 0.206-0.596 0.4913l-2.867 14.75c-0.03461 0.178 0.01214 0.3621 0.12742 0.5021 0.11538 0.1399 0.28723 0.2209 0.46859 0.2209h3.2134c0.2907 0 0.5406-0.2061 0.5961-0.4914l0.6667-3.4301h2.2518c1.2734 0 2.3454-0.1389 3.1859-0.4126 0.8644-0.2809 1.6597-0.757 2.3636-1.4152 0.5822-0.5356 1.0617-1.1367 1.425-1.7869 0.3635-0.6504 0.6246-1.3757 0.7761-2.1558 0.376-1.9333 0.0705-3.4814-0.9077-4.6011-0.9688-1.109-2.4912-1.6712-4.5246-1.6712zm-4.6184 9.108h1.9546c1.2955 0 2.2606-0.244 2.8946-0.7321 0.6342-0.4882 1.0619-1.303 1.2841-2.4447 0.2127-1.0962 0.1158-1.8698-0.2905-2.3204-0.4069-0.4507-1.2205-0.676-2.4412-0.676h-2.2017l-1.1999 6.1732zm4.6184-8.5008c1.8588 0 3.2149 0.4877 4.0673 1.4634 0.8523 0.9757 1.1089 2.3375 0.7689 4.086-0.14 0.7202-0.3767 1.3787-0.71 1.9753-0.3337 0.597-0.7694 1.1428-1.3078 1.6378-0.6417 0.6004-1.3545 1.0283-2.1388 1.2831-0.7844 0.2556-1.7834 0.3828-2.9979 0.3828h-2.7524l-0.7622 3.9215h-3.2134l2.867-14.75h6.1793z",
							fill: "#262626"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "m31.179 33.416c-0.0907 0-0.1766-0.0405-0.2342-0.1105-0.0578-0.0699-0.0812-0.1619-0.0639-0.251l1.2683-6.5263c0.1206-0.6206 0.0908-1.0661-0.0837-1.2544-0.1069-0.115-0.428-0.308-1.3772-0.308h-2.2976l-1.5945 8.2045c-0.0277 0.1427-0.1527 0.2457-0.2981 0.2457h-3.188c-0.0907 0-0.1766-0.0405-0.2343-0.1105-0.0577-0.0699-0.0811-0.162-0.0638-0.251l2.867-14.75c0.0278-0.1426 0.1528-0.2456 0.2981-0.2456h3.188c0.0907 0 0.1766 0.0405 0.2343 0.1104 0.0577 0.07 0.0811 0.162 0.0638 0.2511l-0.6919 3.56h2.4717c1.883 0 3.1598 0.3319 3.9035 1.0148 0.758 0.6967 0.9946 1.8106 0.7031 3.3112l-1.3339 6.8639c-0.0278 0.1427-0.1526 0.2457-0.2981 0.2457h-3.2386z",
							fill: "#fff"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "m29.364 17.755h-3.1881c-0.2907 0-0.5406 0.2061-0.5961 0.4914l-2.867 14.75c-0.0346 0.178 0.0122 0.3621 0.1275 0.502 0.1154 0.14 0.2873 0.221 0.4686 0.221h3.1881c0.2906 0 0.5406-0.2061 0.5961-0.4914l1.5467-7.9589h2.0474c0.9476 0 1.1464 0.2024 1.1544 0.2112 0.0575 0.0618 0.1331 0.3482 0.0083 0.9898l-1.2682 6.5263c-0.0346 0.178 0.0122 0.3621 0.1275 0.502 0.1154 0.14 0.2873 0.221 0.4686 0.221h3.2387c0.2906 0 0.5406-0.2061 0.5961-0.4914l1.3338-6.8639c0.313-1.6112 0.0452-2.8198-0.7956-3.5926-0.8024-0.7368-2.1464-1.095-4.1089-1.095h-2.1035l0.6217-3.1984c0.0345-0.178-0.0122-0.3622-0.1275-0.502-0.1154-0.14-0.2873-0.2211-0.4686-0.2211zm0 0.6072-0.7622 3.9215h2.8401c1.787 0 3.0196 0.3119 3.698 0.9349 0.6784 0.6234 0.8816 1.6335 0.6105 3.0298l-1.3339 6.8638h-3.2387l1.2683-6.5262c0.1443-0.7424 0.0912-1.2488-0.1594-1.5188s-0.7839-0.4053-1.5995-0.4053h-2.548l-1.6422 8.4503h-3.1881l2.867-14.75h3.1881z",
							fill: "#262626"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "m41.094 30.481c1.2211 0 2.1326-0.2251 2.7094-0.669 0.5706-0.4392 0.9647-1.2003 1.1714-2.2621 0.1926-0.9924 0.1192-1.6853-0.2181-2.0593-0.3448-0.3819-1.0903-0.5756-2.2157-0.5756h-1.9514l-1.0818 5.566h1.5862zm-6.3824 6.8563c-0.0905 0-0.1766-0.0404-0.2342-0.1105-0.0576-0.0699-0.0811-0.162-0.0638-0.251l2.867-14.75c0.0278-0.1426 0.1527-0.2456 0.2982-0.2456h6.179c1.9421 0 3.3874 0.5273 4.296 1.5673 0.9134 1.0454 1.1954 2.5068 0.8383 4.3436-0.1455 0.7483-0.3954 1.4432-0.743 2.0654-0.3481 0.6229-0.8081 1.1992-1.3674 1.7133-0.6696 0.6267-1.4275 1.081-2.2505 1.3484-0.81 0.2638-1.8502 0.3976-3.0917 0.3976h-2.5021l-0.7143 3.6758c-0.0278 0.1427-0.1527 0.2457-0.2981 0.2457h-3.2134z",
							fill: "#fff"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "m40.839 25.219h1.7011c1.3583 0 1.8301 0.298 1.9905 0.4757 0.266 0.2949 0.3162 0.9166 0.1452 1.7979-0.1921 0.9868-0.5483 1.6864-1.0584 2.0792-0.5225 0.4022-1.3718 0.606-2.5243 0.606h-1.2178l0.9637-4.9588zm2.9179-3.542h-6.1791c-0.2907 0-0.5406 0.2061-0.596 0.4913l-2.867 14.75c-0.0346 0.178 0.0121 0.362 0.1274 0.502 0.1154 0.14 0.2872 0.2209 0.4686 0.2209h3.2133c0.2907 0 0.5407-0.206 0.5961-0.4913l0.6667-3.4302h2.2518c1.2734 0 2.3453-0.1388 3.1859-0.4126 0.8644-0.2808 1.6599-0.757 2.3638-1.4154 0.5821-0.5354 1.0614-1.1364 1.4248-1.7866 0.3634-0.6505 0.6245-1.3758 0.776-2.1558 0.376-1.9334 0.0706-3.4816-0.9077-4.6013-0.9688-1.1088-2.491-1.6711-4.5246-1.6711zm-4.6183 9.108h1.9545c1.2956 0 2.2606-0.244 2.8947-0.7321 0.6342-0.4882 1.0618-1.3029 1.2841-2.4447 0.2127-1.0962 0.1159-1.8697-0.2906-2.3204-0.4068-0.4506-1.2204-0.676-2.4412-0.676h-2.2017l-1.1998 6.1732zm4.6183-8.5008c1.8589 0 3.215 0.4878 4.0674 1.4635 0.8523 0.9756 1.1089 2.3375 0.7688 4.0859-0.1399 0.7203-0.3767 1.3788-0.7099 1.9753-0.3337 0.597-0.7694 1.1429-1.3079 1.6379-0.6416 0.6004-1.3544 1.0283-2.1388 1.2831-0.7843 0.2555-1.7833 0.3827-2.9978 0.3827h-2.7525l-0.7621 3.9215h-3.2133l2.867-14.75h6.1791z",
							fill: "#262626"
						})
					]
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "d",
			children: /* @__PURE__ */ _jsx("rect", {
				transform: "translate(0 .2639)",
				width: 58,
				height: 58,
				fill: "#fff"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgPhpDark);
export { ForwardRef as ReactComponent };
